import { FirebaseApp, FirebaseOptions, initializeApp } from '@firebase/app';

let app: FirebaseApp;

export function initFirebase(config?: FirebaseOptions): FirebaseApp {
  if (!config && !app) throw new Error('No firebase configuration object provided!');
  if (!app && config) {
    app = initializeApp(config);
  }
  return app;
}
